import { Link } from "gatsby"
import React from "react"
import { CarouselSection } from "../../../CarouselSection"
import "./polycom.scss"

export const ComponentesPolycom = ({
  classTitle,
  polycomInfo,
  images,
  s1920,
  s1366,
  s1024,
  s768,
  s640,
  s360,
  cover,
}) => {
  return (
    <div
      className={`${classTitle}-container`}
      data-sal="slide-up"
      data-sal-delay="200"
      data-sal-easing="ease"
    >
      <div className={`${classTitle}-info-container`}>
        <div className={`${classTitle}-info-title-container`}>
          <h3 className={`${classTitle}-title`}>{polycomInfo.title[0]}</h3>
          <span>{polycomInfo.title[1]}</span>
        </div>
        <div className={`${classTitle}-description-container`}>
          {polycomInfo.description
            ? polycomInfo.description.map(el => (
                <p className={`${classTitle}-description`}>{el}</p>
              ))
            : null}
        </div>
        {polycomInfo.list ? (
          <ul>
            {polycomInfo.list.map(el => (
              <li>{el}</li>
            ))}
          </ul>
        ) : null}
      </div>

      <div className={`${classTitle}-button-container`}>
        <Link className="soluciones-btn" to="/contacto">
          <button className={`${classTitle}-button`}>COTIZAR</button>
        </Link>
      </div>

      <CarouselSection
        classTitle={classTitle}
        images={images}
        s1920={s1920}
        s1366={s1366}
        s1024={s1024}
        s768={s768}
        s640={s640}
        s360={s360}
        cover={true}
      />
    </div>
  )
}
